import { useSiteContent } from '../../context/SiteContentContext';
import './StorePauseBanner.css';

export default function StorePauseBanner() {
  var content = useSiteContent();
  var c = content.c;
  var status = c('store_status', 'open');

  if (status !== 'paused') return null;

  var message = c('store_pause_message', 'Orders are currently paused.');
  var reopenDate = c('store_pause_reopen', '');

  return (
    <div className="pause-banner">
      <span className="pause-banner__msg">{message}</span>
      {reopenDate && <span className="pause-banner__date">Reopening: {reopenDate}</span>}
    </div>
  );
}